import script from "./DecasTable.vue?vue&type=script&setup=true&lang=js"
export * from "./DecasTable.vue?vue&type=script&setup=true&lang=js"

import "./DecasTable.vue?vue&type=style&index=0&id=4876465c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4876465c"]])

export default __exports__